import React, { createContext, useState, useEffect } from "react";

// Create the context
export const GalleryContext = createContext();

// Create a provider component
export const GalleryProvider = ({ children }) => {
  const [works, setWorks] = useState({});
  const [selectedWork, setSelectedWork] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Function to fetch a single work by ID
  const fetchSingleWork = (workId) => {
    if (!workId || works[workId]) return; // Skip if we already have this work or no ID
    
    setIsLoading(true);

    const isOldApi = String(workId).length <= 6;
    const galleryApiUrl = isOldApi 
      ? process.env.GATSBY_ORS_GALLERY + "/" + workId
      : process.env.GATSBY_PORTAL_GALLERY + workId;

    fetch(galleryApiUrl, {
      headers: {
        Accept: "application/json"
      },
    })
      .then(response => response.json())
      .then(responseJson => {
        // Store the fetched work in our works object with the ID as key
        setWorks(prevWorks => ({
          ...prevWorks,
          [workId]: responseJson
        }));

        setIsLoading(false);
      })
      .catch(error => {
        console.log("Error fetching work:", error);
        setIsLoading(false);
      });
  };

  // Function to select a work (makes it easily accessible)
  const selectWork = (workId) => {
    if (works[workId]) {
      setSelectedWork(works[workId]);
    } else {
      // If we don't have this work yet, fetch it
      fetchSingleWork(workId);
    }
  };

  // Provide all the context values to consuming components
  return (
    <GalleryContext.Provider value={{
      works,
      selectedWork,
      isLoading,
      fetchSingleWork,
      selectWork,
      setSelectedWork,
    }}>
      {children}
    </GalleryContext.Provider>
  );
};

// Custom hook to use the gallery context
export const useGallery = () => {
  const context = React.useContext(GalleryContext);
  if (context === undefined) {
    throw new Error("useGallery must be used within a GalleryProvider");
  }
  return context;
};